import { createStore } from "vuex";
import api from "@/api";

export default createStore({
  state: {
    user: JSON.parse(localStorage.getItem("user")) || null,
    token: localStorage.getItem("token") || null,
  },

  getters: {
    isAuthenticated(state) {
      return !!state.user;
    },

    userId(state) {
      return state.user?.id || null;
    },
  },

  mutations: {
    SET_AUTH(state, payload) {
      state.user = payload.user;
      state.token = payload.token;

      localStorage.setItem("user", JSON.stringify(payload.user));
      localStorage.setItem("token", payload.token);
    },

    CLEAR_AUTH(state) {
      state.user = null;
      state.token = null;

      localStorage.removeItem("user");
      localStorage.removeItem("token");
    },
  },

  actions: {
    async register(_, formData) {
      return await api.post("/customers/register", formData);
    },

    async login({ commit }, credentials) {
      const response = await api.post("/customers/login", credentials);

      commit("SET_AUTH", {
        user: response.data.user,
        token: response.data.token,
      });

      return response;
    },

    logout({ commit }) {
      commit("CLEAR_AUTH");
    },

    async fetchNotifications({ getters }) {
      return await api.get(`/customers/${getters.userId}/notifications`);
    },

    async fetchBookings({ getters }) {
      return await api.get(`/bookings/user/${getters.userId}`);
    },

    async fetchCurrentBookings({ getters }) {
      return await api.get(`/bookings/current/${getters.userId}`);
    },

    async fetchPastBookings({ getters }) {
      return await api.get(`/bookings/past/${getters.userId}`);
    },

    async createBooking(_, bookingData) {
      return await api.post("/bookings", bookingData);
    },

    async payBooking(_, paymentData) {
      return await api.post("/payments/pay", paymentData);
    },

    async fetchLocations({ getters }) {
      return await api.get(`/locations/user/${getters.userId}`);
    },

    async addLocation(_, locationData) {
      return await api.post("/locations", locationData);
    },

    async getWeather(_, locationId) {
      return await api.get(`/locations/${locationId}/weather`);
    },

    async deleteLocation(_, locationId) {
      return await api.delete(`/locations/${locationId}`);
    },

    async updateLocation(_, { locationId, locationData }) {
      return await api.put(`/locations/${locationId}`, locationData);
    },

    async previewPayment(_, payload) {
      return await api.post("/payments/preview", payload);
    },
  },
});